/**
 * Extrai os serviços citados de uma mensagem persistida.
 *
 * Lê `message.tool_calls`, encontra a entrada `name === 'citar_servicos'` e devolve
 * `output.itens`. É o que faz a mensagem **reaberta** renderizar igual à versão **ao
 * vivo**: uma extração, dois caminhos, sem coluna nova no banco.
 *
 * Mensagens anteriores à feature não têm `output` — devolvem lista vazia, sem quebrar.
 *
 * @param {Object} message Mensagem no shape que o backend persiste (ver `ToolCallRegistrado`).
 * @returns {Array} Itens `ServicoCitado`, ou `[]`.
 */
export function extrairServicosCitados(message) {
  if (!message || !message.tool_calls || !message.tool_calls.length) return []
  for (const chamada of message.tool_calls) {
    if (chamada && chamada.name === 'citar_servicos' && chamada.output && chamada.output.itens) {
      return chamada.output.itens
    }
  }
  return []
}
